<template>
    <div>
        <div class="input-group">
            <div class="input-group-prepend">
                <input id="search" class="form-control" type="text" placeholder="Search items here" v-model="internalValue">
            </div>
            <div class="input-group-append">
                <button type="button" class="btn btn-primary" @click="search">Search</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SearchBar",

        props: {
            value: {
                type: String,
                default: "",
            }
        },

        computed: {
            internalValue: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                }
            }
        },

        methods: {
            search() {
                this.$emit("search");
            }
        }
    }
</script>

<style scoped>
    input[type=text] {
        min-width: 360px;
    }
</style>